// extracted by mini-css-extract-plugin
module.exports = {"textarea":"cd01fbf7b5--textarea--p58Ff","counter":"cd01fbf7b5--counter--EYsRq"};